

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { formatDegree, formatNum } from "./utils/space"
class AngleSpace extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.style = {
            clampToGround: false
        }
        this.entitiesLabel=[];
    }

    leftClick(evt) {

        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if (!position) {
            return;
        }

        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
            var label = ConstantDraw.Style_Label;
            label.text = "起点";
            this.startPoint = this.createPoint(position);
            this.startPoint.label = label;
            this.entities.push(this.startPoint);
            this.entitiesLabel.push(this.startPoint);
        }

        if ($this.positions.length <= 2) {
            $this.positions.push(position);
        }

        if ($this.positions.length == 3 && !this.centerPoint) {
            var label = ConstantDraw.Style_Label;
            label.text = "终点";
            this.endPoint = this.createPoint(position);
            this.endPoint.label = label;

            this.centerPoint = this.createPoint(position); //中点

            this.entities.push(this.centerPoint);
            this.entities.push(this.endPoint);
            this.entitiesLabel.push(this.centerPoint);
            this.entitiesLabel.push(this.endPoint);
        }
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!cartesian) {
            return;
        }
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createPolyline($this.positions,this.style);
            this.entities.push($this.plot);
        }
        if ($this.plot) {
            $this.positions.pop();
            $this.positions.push(cartesian);

        }
        if ($this.centerPoint) {
            this.endPoint.position.setValue(cartesian);
            this.updateBear();
        }
    }
    initEditor() {
    }

    reset() {
        super.reset();
        this.startPoint = null;
        this.endPoint = null;
        this.centerPoint = null;
        this.entitiesLabel=[];
    }


    updateBear() {
        var point1 = this.startPoint.position.getValue();
        var point2 = this.endPoint.position.getValue();
        var center = this.centerPoint.position.getValue();
        var angle = this.getAngleCenterPointDirNor(center, point1, point2);
        var label = ConstantDraw.Style_Label;
        label.text = "角度:" + formatDegree(angle) + "\n(度数):" + formatNum(angle, 6);
        this.centerPoint.label = label;
    }

    //获取以center为中心的A和B坐标夹角，有方向,正常
    getAngleCenterPointDirNor(center, pointA, pointB) {
        //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //a点在局部坐标的位置，其实就是局部坐标原点
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在以A点为原点的局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        //弧度
        const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
        const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);
        const angle = angle2 - angle1;
        angle;

        //角度
        let theta = angle * (180 / Math.PI);
        // if (theta < 0) {
        //   theta = theta + 360;
        // }
        return theta;
    }

}

export default AngleSpace;